"use client";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import cn from "classnames";
import { type PropsWithChildren, type ReactNode, useState } from "react";
import s from "./Ribbon.module.scss";

export interface RibbonProps {
  logo: ReactNode;
}

export default function Ribbon(props: PropsWithChildren<RibbonProps>) {
  const { logo, children } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={cn(s.wrapper, isOpen ? s.open : s.close)}>
      <div className={s.content}>
        {children}
        <div className={s.toggle} onClick={handleOpen}>
          {logo}
          <div className={s.toggleIcon}>
            {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </div>
        </div>
      </div>
    </div>
  );
}
